import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Necesito saber psicología para entender el contenido?',
  a: 'No. El pack está diseñado para personas sin formación previa. Todo está explicado con ejemplos cotidianos, ejercicios prácticos y lenguaje directo. Si podés leer esta página, podés entender el pack.'
}, {
  q: '¿Cómo recibo los materiales después de comprar?',
  a: 'Al instante. Apenas confirmás el pago recibís un email con los links de descarga de todos los PDFs. Acceso inmediato, sin esperas, sin instalaciones.'
}, {
  q: '¿Funciona en celular?',
  a: 'Sí. Los PDFs están optimizados para celular, tablet y PC. Podés leerlos en cualquier dispositivo con lector de PDF (el que ya tenés instalado).'
}, {
  q: '¿Cuánto tiempo necesito para aplicar lo que aprendo?',
  a: 'Desde el primer tomo ya podés aplicar ejercicios en el mismo día. El pack incluye técnicas de implementación inmediata. No necesitás terminar todo para empezar a ver resultados.'
}, {
  q: '¿Qué pasa si me equivoco al leer a alguien?',
  a: 'Por eso el sistema enseña clusters y baseline, no gestos aislados. Un gesto solo nunca es suficiente. El método te entrena para confirmar antes de concluir — así evitás errores y falsas acusaciones.'
}, {
  q: '¿Funciona para detectar infidelidad?',
  a: 'El pack enseña a leer señales de estrés, engaño y distanciamiento emocional. No es una prueba legal, pero sí te da claridad para saber si algo no está cerrando y cómo abordarlo sin drama.'
}, {
  q: '¿Puedo comprar solo los tomos sin los bonos?',
  a: 'Sí. El Pack Base incluye los 6 tomos sin bonos. El Combo Completo incluye los 6 tomos + 6 bonos + El Protocolo de Sombra. Elegís según tus necesidades en la sección de precios.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 px-4 bg-deep-black" data-id="element-34">
      <div className="max-w-3xl mx-auto" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-36">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-37">
            Preguntas Frecuentes
          </h2>
          <p className="text-xl text-smoke/80" data-id="element-38">
            Todo lo que necesitás saber antes de decidir
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-39">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#141414] border border-white/5 rounded-xl overflow-hidden" data-id="element-40">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none hover:bg-white/5 transition-colors" data-id="element-41">
                <span className="font-heading font-bold text-lg text-white pr-4" data-id="element-42">
                  ❓ {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-electric-blue transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-43" />
              </button>

              <AnimatePresence data-id="element-44">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-45">
                    <div className="px-6 pb-6 pt-2 text-smoke/80 leading-relaxed border-t border-white/5 mx-6" data-id="element-46">
                      ✅ {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}